import { render, staticRenderFns } from "./NsTaxId.vue?vue&type=template&id=55d95c71&scoped=true&"
import script from "./NsTaxId.vue?vue&type=script&lang=js&"
export * from "./NsTaxId.vue?vue&type=script&lang=js&"
import style0 from "./NsTaxId.vue?vue&type=style&index=0&id=55d95c71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d95c71",
  null
  
)

export default component.exports